<div class="side-nav-bar sideBarContainer">
  <div class="main-actions">
    <ul>
      <li>
        <a
          tabindex="0"
          (keyup.enter)="goToAppHubUsersPage()"
          [ngClass]="{ isSelected: isAppHubContext }"
          data-testid="linkMyApps"
          class="no-href-link"
          (click)="goToAppHubUsersPage()"
        >
          <span class="navItemText">
            <app-icon source="rn-grid" imgClass="filter-white"></app-icon>&nbsp; My Apps
          </span>
        </a>
      </li>
      @if (!isAzure) {
        <li>
          <a
            tabindex="0"
            (keyup.enter)="openFileManager()"
            class="no-href-link"
            (click)="openFileManager()"
            data-testid="linkFileManager"
          >
            <span class="navItemText">
              <app-icon source="rn-file" imgClass="filter-white"></app-icon>&nbsp; File Manager
            </span>
          </a>
        </li>
      }
      @if (showAdminConsole) {
        <li>
          <a
            tabindex="0"
            (keyup.enter)="goToAdminConsole()"
            [ngClass]="{ isSelected: isAdminContext }"
            data-testid="linkAdminConsole"
            class="no-href-link"
            (click)="goToAdminConsole()"
          >
            <span class="navItemText">
              <app-icon source="rn-settings" imgClass="filter-white"></app-icon>&nbsp; Admin Controls
            </span>
          </a>
        </li>
      }
      @if (connectUrl && showVisitConnect && !isEntryTier()) {
        <li>
          <a
            tabindex="0"
            (keyup.enter)="goToConnect()"
            data-testid="linkVisitConnect"
            data-pendo-id="apphub-sidenav-visitConnect-link"
            class="no-href-link"
            (click)="goToConnect()"
          >
            <span class="navItemText">
              <app-icon source="rn-visit-connect" imgClass="filter-white"></app-icon>&nbsp; Visit Connect
            </span>
          </a>
        </li>
      }
      @if (!isEntryTier()) {
        <li>
          <a
            tabindex="0"
            (keyup.enter)="goToSecurityHub()"
            data-testid="apphub-sidenav-security-hub-link"
            data-pendo-id="apphub-sidenav-security-hub-link"
            class="no-href-link"
            (click)="goToSecurityHub()"
          >
            <span class="navItemText">
              <app-icon source="rn-secure-lock" imgClass="filter-white"></app-icon>&nbsp;
              Security Hub
            </span>
          </a>
        </li>
      }
      @if (isSolutionHubEnabled && !loadingFeatureFlag && !isEntryTier()) {
        <li>
          <a
            tabindex="0"
            (keyup.enter)="goToSolutionHub()"
            data-testid="apphub-sidenav-solution-hub-link"
            data-pendo-id="apphub-sidenav-solution-hub-link"
            class="no-href-link"
            (click)="goToSolutionHub()"
          >
            <span class="navItemText">
              <app-icon source="rn-puzzle" imgClass="filter-white"></app-icon>&nbsp;Solution Hub
              <rw-badge
                datapendoid="solution-hub-beta-badge"
                datatestid="solution-hub-beta-badge"
                arialabel="solution hub beta badge"
                text="Beta"
                badgeclass="rw-badge-outline-primary"
                extraclass="betaBadge"
                size="sm"
              ></rw-badge>
            </span>
          </a>
        </li>
      }
      @if (communityUrl && !isEntryTier()) {
        <li>
          <a
            tabindex="0"
            (keyup.enter)="goToCommunity()"
            data-testid="apphub-sidenav-community-link"
            data-pendo-id="apphub-sidenav-community-link"
            class="no-href-link"
            (click)="goToCommunity()"
          >
            <span class="navItemText">
              <app-icon source="rn-community" imgClass="filter-white"></app-icon>&nbsp;Community
            </span>
          </a>
        </li>
      }
    </ul>
  </div>
</div>
